import { firebase, db } from '@/firebase';
import { actions, mutations } from '../constants'

const admin = {
  state: {
  },
  mutations:{

  },
  actions:{
    [actions.ADMIN_LIST_SLIDES]({ commit },{from, size, filters={}}) {
     // const db = firebase.firestore();
      const slidesRef = db.collection(`slides`);
      return slidesRef.get()
        .then(snapshot=>{
          const list = [];
          snapshot.forEach(doc=>{
            const data = doc.data();
            list.push({
              id: doc.id,
              slug: data.slug,
              language: data.language,
              status: data.status
            });
          });
          return Promise.resolve(list);
        });
    },
    [actions.ADMIN_CREATE_SLIDE]({rootState, commit}, payload={}){
     // const db = firebase.firestore();
      const data = Object.assign({},payload);
      const contactRef = db.collection(`slides`);
      try{
        contactRef.add(data); //This doesnt return a promise
        return Promise.resolve(true);
      }catch(err){
        return Promise.reject(err);
      }

    },
    [actions.ADMIN_GET_SLIDE]({ commit },id) {
      //const db = firebase.firestore();
      const slideRef = db.collection(`slides`).doc(id);
      return slideRef.get()
        .then(doc=>{
          if(!doc.exists){
            return null;
          }
          return doc.data()
        })
    },
    [actions.ADMIN_UPDATE_SLIDE]({ commit },{id, data={}}) {
      if(!id) return Promise.resolve(false);
     // const db = firebase.firestore();
      const d = Object.assign({},data);

      const slideRef = db.collection(`slides`).doc(id);

      try{
        slideRef.set(d, { merge: true }); //This doesnt return a promise
        return Promise.resolve(true);
      }catch(err){
        return Promise.reject(err);
      }
    },
  }
};

export default admin;



// WEBPACK FOOTER //
// ./src/store/modules/admin.js